export const STATUS_TABS = [
  {
    id: 'notAvailable',
    label: 'Not Available',
    statusValue: 'Not Available',
    icon: 'ri-close-circle-line',
  },
  {
    id: 'revise',
    label: 'Revise',
    statusValue: 'Revise',
    icon: 'ri-error-warning-line',
  },
  {
    id: 'available',
    label: 'Available',
    statusValue: 'Available',
    icon: 'ri-checkbox-circle-line',
  },
];

// '' = All Status: the list opens unfiltered.
export const DEFAULT_STATUS_TAB = '';

export const getStatusValueByTabId = tabId =>
  STATUS_TABS.find(tab => tab.id === tabId)?.statusValue ?? '';
